/**
 * カレンダーのバリデーションに関するサービス
 */
export class CalendarValidationService {
  /**
   * Dateオブジェクトを受け取り、その月よりも前の年月に移動可能かどうかを判定する（日は無視）
   * 当月から5年前までの年月まで移動可能
   * @param date - 日付
   */
  public static isCanMovePreviousMonth = (date: Date): boolean => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // 5年前の月と年を正しく計算
    const fiveYearsAgoYear = currentYear - 5;
    const fiveYearsAgoMonth = currentMonth;

    // 指定された日付の月と年
    const targetMonth = date.getMonth();
    const targetYear = date.getFullYear();

    // 5年前の年より後、または5年前の年で同じ月またはそれ以降であるかをチェック
    return targetYear > fiveYearsAgoYear || (targetYear === fiveYearsAgoYear && targetMonth > fiveYearsAgoMonth);
  };

  /**
   * Dateオブジェクトを受け取り、その月よりも次の年月に移動可能かどうかを判定する
   * 当月から6ヶ月後までの年月まで移動可能
   * @param date - 判定対象の日付
   */
  public static isCanMoveNextMonth = (date: Date): boolean => {
    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    // 6ヶ月後の月と年を計算
    let sixMonthsLaterMonth = currentMonth + 5;
    let sixMonthsLaterYear = currentYear;
    if (sixMonthsLaterMonth > 11) {
      sixMonthsLaterMonth -= 12;
      sixMonthsLaterYear += 1;
    }

    // 指定された日付の月と年
    const targetMonth = date.getMonth();
    const targetYear = date.getFullYear();

    // 指定された日付が6ヶ月以内であるかどうかを判定
    return targetYear < sixMonthsLaterYear || (targetYear === sixMonthsLaterYear && targetMonth <= sixMonthsLaterMonth);
  };
}
